// extracted by mini-css-extract-plugin
export default {"container":"StartPage_container__9R55+"};